import styles from "./iframe.cssx";

console.log('styles', styles);
var link  = document.createElement('style');
link.innerHTML = styles;
console.log(link);

const iframe = document.getElementById('tbniframe')



const handleLoad = () => {
    console.log('loaded')
    const header = iframe.contentDocument.head
    console.log(header);
    header.appendChild(link)
}

iframe.addEventListener('load', handleLoad, true)
